import memberManagementRoutes from '../routers/member/memberManagement'
import memberOperationalToolsRoutes from '../routers/member/operationalTools'
import memberChannel from '../routers/member/channel'
import rechargeMangement from '../routers/member/rechargeMangement'
import marketingRoutes from '../routers/marketing'
import marketingContentRoutes from '../routers/marketing/content'
import marketingInteractionRoutes from '../routers/marketing/interaction'
import settingSystemSettingRoutes from '../routers/setting/systemSetting'
import messageRoutes from '../routers/message'
import cdpRoutes from '../routers/cdp'
import notificationSet from './notificationSet'
import marketingCouponRoutes from './marketing/coupon'
import attributeSettingUser from '../routers/attributeSettingUser'
import wxRedEnvelopeRoutes from '../routers/wxRedEnvelope'
import emailRoutes from '../routers/email'
import webHook from './webHook'
import ChannelManagementRoutes from './channelManagement'
import IntegralMall from './integralMall'
import GoodsRoutes from './appMails/goods'
import OrderRoutes from './appMails/order'
import OperateRoutes from './appMails/operate'
import ActiveRoutes from './appMails/actives'

const routes = [
  // 会员运营
  ...memberChannel,
  ...memberManagementRoutes,
  ...memberOperationalToolsRoutes,
  ...marketingRoutes,
  ...marketingContentRoutes,
  ...marketingCouponRoutes,
  ...rechargeMangement,

  // 管理中心
  ...messageRoutes,
  ...cdpRoutes,
  ...marketingInteractionRoutes,
  ...settingSystemSettingRoutes,

  ...notificationSet,
  // 基础设置
  ...attributeSettingUser,
  ...webHook,
  // 微信紅包
  ...wxRedEnvelopeRoutes,
  // 邮件服务
  ...emailRoutes,
  // 渠道管理
  ...ChannelManagementRoutes,
  // 积分商城
  ...IntegralMall,

  // 小程序商城
  ...GoodsRoutes,
  ...OrderRoutes,
  ...OperateRoutes,
  ...ActiveRoutes
]

export default routes
